import _ from 'lodash'
import { ConceptValueDataType } from '@fusion-advantage/backcompat'
import { Concept, ConceptsByCid, newConcept } from "../concept/Concept"

export enum CommonResponse {
	Yes = 'cKE3L7yoCdX8PzKSXXVKS1kF',
	No = 'c2s1CYRtjqvUzKYhAoyRAAy1',
	Unknown = 'cvip6pb5jAvh05YSF7wJC1qN',
	NotApplicable = 'cX9073BeLMMspl8PFSzbtQN0',
	Normal = 'cgvdJ7DmtJqQaZWLoq3lNlEM',
	Abnormal = 'cl3kFbYY66KdYH0qsB04FGtX',
	Negative = 'cmeaz807AtapeIJRg82lZsd2',
	Positive = 'c9IR5Egp8F30gyqdnls0UiC4',
	Present = 'cgKFnvVwyO61EsKGdveN0toG',
	Absent = 'c0m0ze1h395DPkeHKDT4jy9Y',
	Never = 'cD3730Aj5OMPs9p582gsFMOT', 
	Rarely = 'cxEWduhZ50sj7AIV2Ls6TW9O',
	Sometimes = 'c6o6UILZInh0zlPganftluFh',
	FairlyOften = 'cMLVrgb73IeSFAaEhByspNbY',
	Frequently = 'czwpXC6eHrgH7QaQ7TY0JHFk',
	NotAtAll = 'cZyFA2nfbbHdruUq8OmFSXCY',
	SeveralDays = 'cSnWEH26GotZJbNErjXGfJFp',
	MoreThanHalfTheDays = 'cue3MaoxVnUKa0VCmuWOWAIh',
	NearlyEveryDay = 'cq3i6POr8Papcd4oSGWTgplq',
	OD = 'cs9Cv7rmFsMdRahLrHw5q1rV',
	OS = 'cinj5MoBnVJWPozx15cQ0fiB',
	OU = 'c0rECtNRVcp9Y82oZmQLRLgf',
	Slow = 'cdz0TGXlrfMCFVz0TfXJZHE5',
	Moderate = 'cbFYDa5gWSKLGzYLXbEnEkkt',
	High = 'c6C0X0eWpaWJQntSc95it762',
	Low = 'cUf6zOAisirGOGUVv8xc7Kka',
	Strong = 'cYVO1oHyT7Yo5XpRzgzqk4gY',
	Weak = 'ctoggaZpmEu7CQYUQRZ5qxQd',
	Refused = 'chKcBOoW3khg1VoaJNHckXif',
	Unable = 'cm9mTrMbZdOPqmNjztXu7jZQ',
}

const commonConcepts: Concept[] = [
	newConcept(CommonResponse.Yes, 'Yes'),
	newConcept(CommonResponse.No, 'No'),
	newConcept(CommonResponse.Unknown, 'Unk'),
	newConcept(CommonResponse.NotApplicable, 'N/A'),
	newConcept(CommonResponse.Normal, 'NL'),
	newConcept(CommonResponse.Abnormal, 'ABN'),
	newConcept(CommonResponse.Negative, '-'),
	newConcept(CommonResponse.Positive, '+'),
	newConcept(CommonResponse.Present, 'Present'),
	newConcept(CommonResponse.Absent, 'Absent'),
	newConcept(CommonResponse.Never, 'Never'),
	newConcept(CommonResponse.Rarely, 'Rarely'),
	newConcept(CommonResponse.Sometimes, 'Sometimes'),
	newConcept(CommonResponse.FairlyOften, 'Fairly often'),
	newConcept(CommonResponse.Frequently, 'Frequently'),
	newConcept(CommonResponse.NotAtAll, 'Not at all'),
	newConcept(CommonResponse.SeveralDays, 'Several days'),
	newConcept(CommonResponse.MoreThanHalfTheDays, 'More than half the days'),
	newConcept(CommonResponse.NearlyEveryDay, 'Nearly every day'),
	newConcept(CommonResponse.OD, 'OD'),
	newConcept(CommonResponse.OS, 'OS'),
	newConcept(CommonResponse.OU, 'OU'),
	newConcept(CommonResponse.Slow, 'Slow'),
	newConcept(CommonResponse.Moderate, 'Moderate'),
	newConcept(CommonResponse.High, 'High'),
	newConcept(CommonResponse.Low, 'Low'),
	newConcept(CommonResponse.Strong, 'Strong'),
	newConcept(CommonResponse.Weak, 'Weak'),
	newConcept(CommonResponse.Refused, 'Refused'),
	newConcept(CommonResponse.Unable, 'Unable'),
]

// unfortunately for now we need to use this hack to trigger some calcs
export const AsyncResultHashConcept: Concept = newConcept(
	'cXTSGRK4AHz25tQKnPX7P2ln',
	'[Internal] Async Result Hash',
	ConceptValueDataType.String,
)

export const MahcAssessmentScoreConcept: Concept = newConcept(
	'cS95vzld3UsevacByjF1Lq4T',
	'[GeneralConcepts] MAHC Assessment Score',
	ConceptValueDataType.Integer,
)

// stores the code from the scanned "leave behind" card
export const LeaveBehindConcept: Concept = newConcept(
	'ct9gnmo2WuKA0LW6CIAOVTG6',
	'Leave Behind Card',
	ConceptValueDataType.String,
)

export const ExamInfoSummaryConcept: Concept = newConcept(
	'c9nH8GF5kDegwS97yiCYukl1',
	'[GeneralConcepts] Exam Info Summary',
	ConceptValueDataType.String,
)

export const PhysicianListConcept: Concept = newConcept(
	'c2EaClAu7lmhH9PjAecLu5ZL',
	'[GeneralConcepts] Physicians List',
	ConceptValueDataType.JSON,
)

export const DMESupplierListConcept: Concept = newConcept(
	'cUWrHr38TGg7qi1OEn19T374',
	'[GeneralConcepts] DME Supplier List',
	ConceptValueDataType.JSON,
)

export const ResultingDiagnosisConcept: Concept = newConcept(
	'cPFAS80oGIbBd5PhCCGriPa9',
	'[GeneralConcepts] Resulting Diagnosis',
	ConceptValueDataType.Object,
)

export const PrescriptionHistoryConcept: Concept = newConcept(
	'cAy9TAm54kiWM7QeboKtQNiC',
	'[DatabaseConcepts] Prescription History',
	ConceptValueDataType.Object,
)

export const PrescriptionReviewConcept: Concept = newConcept(
	'cqAOaVYBzOjOUE7DvXhQR4AY',
	'[GeneralConcepts] Prescription Review',
	ConceptValueDataType.Object,
)

export const DiagnosisReviewConcept: Concept = newConcept(
	'cN4Kb0O01anFWT4c82ZUmVJj',
	'[GeneralConcepts] Diagnosis Review',
	ConceptValueDataType.Object,
)

export const OncologyReviewConcept: Concept = newConcept(
	'czzRLSxOjOB4tdpZ95pCOIiw',
	'[GeneralConcepts] Oncology Review',
	ConceptValueDataType.Object,
)

export const UlcerReviewConcept: Concept = newConcept(
	'cVn3QLaeZtO8rSYp1wBxIMdu',
	'[GeneralConcepts] Ulcer Review',
	ConceptValueDataType.Object,
)

export const NeurologicWeaknessConcept: Concept = newConcept(
	'csHN8O6sYplHeGS8EhxDRy4K',
	'[GeneralConcepts] Neurologic Weakness Review',
	ConceptValueDataType.Object,
)

export const LabRecommendationsConcept: Concept = newConcept(
	'c1IFREZbhO6iAiDQB68FvYUv',
	'[DatabaseConcepts] Lab Recommendations',
	ConceptValueDataType.Object,
)

export const LabResultsConcept: Concept = newConcept(
	'cdIR5iQsJ302OrmLNFBwzUVa',
	'[DatabaseConcepts] Lab Results',
	ConceptValueDataType.Object,
)

export const LabsConcept: Concept = newConcept(
	'cajO0HYg1PfTIPIdSBOpT4x3',
	'[GeneralConcepts] Labs',
	ConceptValueDataType.Object,
)

export const SurgicalHistoryOtherProceduresConcept: Concept = newConcept(
	'cKWNvy3H5rQryirul5hLHjjH',
	'[GeneralConcepts] Surgical History & Other Procedures',
	ConceptValueDataType.JSON,
)

export const OutsideLabsAvailableConcept: Concept = newConcept(
	'cmztwu6PJuip88gB7LNZv428',
	'[GeneralConcepts] Outside Labs Available',
	ConceptValueDataType.JSON,
)

export const DrugDisposalConcept: Concept = newConcept(
	'cLzU1knucMqX0M9qDn1xTabJ',
	'[DatabaseConcepts] Drug Disposal',
	ConceptValueDataType.Object,
)

export const ClaimHistoryConcept: Concept = newConcept(
	'cbPvfZnZXW7Vrqtp8B14SPWi',
	'[DatabaseConcepts] Claim History',
	ConceptValueDataType.Object,
)

export const AdhocDxConcept: Concept = newConcept(
	'cTcbI9gTo2gvYkPGQwWEY8xO',
	'[GeneralConcepts] Adhoc Dx',
	ConceptValueDataType.Object,
)

export const GeneralNotesConcept: Concept = newConcept(
	'cpPvfZnFXW6Vrqvp7B13grBI',
	'[GeneralConcepts] General Notes',
	ConceptValueDataType.String,
)

// because this message is currently in the "description" of 1080
// not the title!
export const GeneralNotesWarningConcept: Concept = newConcept(
	'cCt6kp4zS5qZykSkI2p6s5h7',
	'Please use this note section ONLY to make necessary clarifications, or to document a chronic condition or situation not found elsewhere in the form. Do not use this section for logistics, scheduling, or any other non-clinical issue. Clinical issue should pertain to this patient directly.',
)

export const PatchScores20240731Concept: Concept = newConcept(
	'c9wfStAtsGftRDHKox20kA1k',
	'[GeneralConcepts] Patch Scores 20240731',
	ConceptValueDataType.Integer,
)

export const ComorbidityConcept: Concept = newConcept(
	'crdaGHJBmwSZwHMpXn07PzgP',
	'[GeneralConcepts] ComorbidityConcept',
	ConceptValueDataType.String,
)

// dan asked us to add this to the codebase so that it would naturally
// get created during a flowmap compile, but only his backend process will
// read or write the data in this result.  the form will have a button to pull
// a fresh real-time copy from the proc while online (if offline, fail!)
// and only that real-time copy of the data will ever be displayed.
export const AuditBypassResultsConcept: Concept = newConcept(
	'cC0q0Ltaw3xuE8uj0H71ba16',
	'[DatabaseConcepts] AuditBypass Results',
	ConceptValueDataType.JSON,
)

export const HedisResultsConcept: Concept = newConcept(
	'cr9kp7HHMPpT7ULZnkgq6aVI',
	'[DatabaseConcepts] Hedis Results',
	ConceptValueDataType.JSON,
)

export const CollaboratingPhysicianSignatureNameConcept: Concept = newConcept(
	'c9e41f2ab03d7c8e51c',
	'[GeneralConcepts] Collaborating Physician Signature Name',
	ConceptValueDataType.String,
)

export const SerializableGeneralConcepts: ConceptsByCid = _.keyBy([
	...commonConcepts,
	AsyncResultHashConcept,
	LeaveBehindConcept,
	ExamInfoSummaryConcept,
	PhysicianListConcept,
	DMESupplierListConcept,
	ResultingDiagnosisConcept,
	PrescriptionHistoryConcept,
	PrescriptionReviewConcept,
	DiagnosisReviewConcept,
	OncologyReviewConcept,
	UlcerReviewConcept,
	NeurologicWeaknessConcept,
	LabRecommendationsConcept,
	LabResultsConcept,
	LabsConcept,
	SurgicalHistoryOtherProceduresConcept,
	OutsideLabsAvailableConcept,
	DrugDisposalConcept,
	ClaimHistoryConcept,
	AdhocDxConcept,
	GeneralNotesConcept,
	GeneralNotesWarningConcept,
	PatchScores20240731Concept,
	ComorbidityConcept,
	AuditBypassResultsConcept,
	HedisResultsConcept,
	CollaboratingPhysicianSignatureNameConcept,
	MahcAssessmentScoreConcept,
], 'cid')
